.container {
	display: flex;
	flex-direction: column;
	flex: 1;
	min-width: var(--jpo-common-min-app-width);
	padding: 0;
	position: relative;
}

.content-header {
	border-bottom: 1px solid var(--ds-border, var(--adg3-color-N50));
	display: flex;
	flex-direction: row;
	height: 90px;
}

.content-row {
	display: flex;
	flex-direction: row;
	flex: 1 0 auto;
	position: relative;
	overflow: hidden;
}

.content-scroller {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	overflow-x: hidden;
	overflow-y: auto;
	display: flex;
}

.content-scroller-export {
	display: flex;
}

.contentArea {
	min-height: 100%;
}

.optimized {
	background: var(--ds-surface, var(--adg3-color-N0));
	background-image: repeating-linear-gradient(
		135deg,
		transparent,
		var(--ds-background-neutral, rgba(101, 84, 192, 0.1)) 1px,
		var(--ds-background-neutral, rgba(101, 84, 192, 0.1)) 16px,
		transparent 17px,
		transparent 32px
	);
}

.scope-column {
	width: 100%;
	display: flex;
	flex-direction: column;
}

.scope-container {
	width: 100%;
}

.fields-column {
	flex: 1 1 auto;
	height: 100%;
}

.timeline-column {
	flex: 1 0 auto;
	position: relative;
	background: var(--ds-surface, var(--adg3-color-N0));
}

.timeline-column-header::before {
	background: var(--ds-background-neutral, var(--adg3-color-N20));
	content: '';
	height: 50px;
	width: 100%;
	position: absolute;
}

.pointer-cursor {
	cursor: pointer;
}

.space {
	flex: 1 1 auto;
	background-color: var(--ds-surface, var(--adg3-color-N0));
}

.highlight {
	z-index: 7001;
	pointer-events: none;
}

.sticky-headers {
	top: 0;
	left: 0;
	right: 0;
	z-index: 4;
	position: absolute;
}

/* Remove when cleaning up arj-remove-row-warning-highlighting_jqjs5 */
.rowHighlighter {
	position: absolute;
	pointer-events: none;
	opacity: 0;
	width: 100%;
	height: 100%;
}

.mainSectionsWrap {
	flex: 1;
	display: flex;
	flex-direction: column;
}

.mainSections {
	position: relative;
	flex: 1;
	display: flex;
	flex-direction: column;
	&.fullScreen {
		position: fixed;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		background: var(--ds-surface, var(--adg3-color-N0));
		z-index: 1;
		/* The timeline width is debounced, so if you expand the window quickly, you see the stuff behind it.
        We can prevent that by adding an extended white background */
		&::before {
			content: '';
			background: var(--ds-surface, var(--adg3-color-N0));
			position: absolute;
			z-index: -1;
			top: -600px;
			right: -600px;
			bottom: -600px;
			left: -600px;
		}
	}
}

.columnsTexts {
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	z-index: 1;
	pointer-events: none;
}

.horizontalScrollbar {
	position: absolute;
	bottom: 0;
	right: 0;
	z-index: 2;
}
